import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./ResetPassword.html';
import styles from './ResetPassword-hashed.scss';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';

// VARS
const hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: [
        '$scope', '$state', 'oAuth', 'state_plugin_config',
        function ($scope, $state, oAuth, STATE_PLUGIN_CONFIG) {
            this.$onInit = function () {
                // VARS
                const authenticationService = AuthenticationService(oAuth);
                const $ctrl = this;
                const token = $state.params.token;
                let code;
                $ctrl.isResetReqInProgress = false;// animation

                // Default model attr required by gw-pl-inline-ctrl-group directive
                $ctrl.newPassword = {aspects: {}};
                $ctrl.confirmPassword = {aspects: {}};

                function validatePassword(password) {
                    const passwordPolicy = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*#?&])(?=.{10,})';
                    const passwordPolicyRegex = new RegExp(passwordPolicy);
                    let isValid = true;
                    isValid = isValid ? passwordPolicyRegex.test(password) : false;
                    return isValid;
                }

                // METHODS
                const setCtrlParam = ComponentUtil.setCtrlParam($ctrl, $scope);

                function setErrorMessage(value) {
                    setCtrlParam('errorMessage', value);
                }

                // Validate if token still valid
                authenticationService.verifyResetCode(token).then(data => {
                    code = data.res;
                    setCtrlParam('status', 'RESET_PASSWORD');
                }, () => {
                    setCtrlParam('status', 'INVALID_TOKEN');
                });

                $ctrl.changePassword = () => {

                    if (!$ctrl.newPassword.value) {
                        setErrorMessage('fieldEmpty');
                        return;
                    }

                    if ($ctrl.newPassword.value !== $ctrl.confirmPassword.value) {
                        setErrorMessage('fieldsIncorrect');
                        return;
                    }

                    if (!validatePassword($ctrl.newPassword.value)) {
                        setErrorMessage('incorrectPassword');
                        return;
                    }

                    setErrorMessage('');
                    setCtrlParam('isRequestInProgress', true);
                    authenticationService.changePassword({
                        code,
                        new_password: $ctrl.newPassword.value
                    }).then((data) => {
                        authenticationService.login({
                            username: data.result.username,
                            password: $ctrl.newPassword.value
                        })
                            .then(() => {
                                // redirect user to home view
                                $state.go(STATE_PLUGIN_CONFIG.home);
                            }, () => {
                                setCtrlParam('status', 'AUTO_LOGIN_FAILURE');
                            });
                    }).catch((err) => {
                        switch (err.error) {
                            case authenticationService.ERRORS.tokens.invalidTokenOrEmail:
                                setCtrlParam('status', 'INVALID_TOKEN_OR_PASSWORD');
                                break;
                            default:
                                setCtrlParam('status', 'INVALID_ATTEMPT');
                                break;
                        }
                    });
                };

                $ctrl.backToSignIn = () => {
                    $state.go('authLogin');
                };
            };
        }]
};
